var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#050505;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.8,4.7c-0.1-0.4-0.3-0.7-0.6-1L16,2.2C15.6,2,15.2,1.9,14.8,2c-0.4,0.1-0.7,0.3-1,0.6l-1.5,2.2l-5.8,8.4 c-0.4,0.6-0.7,1.4-0.8,2.1l-0.5,3.3c0,0.4,0.1,0.7,0.4,0.9c0.2,0.1,0.3,0.2,0.5,0.2c0.2,0,0.3,0,0.5-0.1L9.5,18 c0.7-0.4,1.3-0.9,1.7-1.5L17,8l1.5-2.2C18.8,5.5,18.9,5.1,18.8,4.7z M10.4,15.9C10,16.4,9.5,16.8,9,17.1l-2.8,1.5l0.5-3.2 c0.1-0.6,0.3-1.2,0.7-1.7l5.6-8l3,2.1L10.4,15.9z M17.7,5.2L16.5,7l-3-2.1l1.2-1.8C14.8,3,14.9,3,15,2.9c0.1,0,0.3,0,0.4,0.1 l2.2,1.5C17.8,4.7,17.9,5,17.7,5.2z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 21.1,
    className: "st0",
    width: 14,
    height: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/icon-edit.d9aa63096aa046802335be48610bef35.svg";
export { ForwardRef as ReactComponent };